import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/free-solid-svg-icons';

export default function Pill({ data, icon, color, className, fullHeight }) {
  return (
    <div
      className={`card-widget ${className || ''} ${fullHeight ? 'h-100' : ''}`}
    >
      <div className="card-widget-body">
        <div className={`dot me-3 bg-${color}`} />
        <div className="text">
          <h6 className="mb-0">{data.name}</h6>
          <span className="text-gray-500">{data.content}</span>
        </div>
      </div>

      <div className={`icon text-white bg-${color}`}>
        <FontAwesomeIcon icon={icon} />
      </div>
    </div>
  );
}

Pill.defaultProps = {
  className: '',
  color: 'primary',
  fullHeight: false,
  icon: faCircle,
};

Pill.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  }).isRequired,
  icon: PropTypes.shape({}),
  color: PropTypes.string,
  className: PropTypes.string,
  fullHeight: PropTypes.bool,
};
